import type { TransactionPredicate } from './types';
import { isEqualAmount } from '../amounts/isEqualAmount';

export const senderAmountDiffersFromReceiverAmount: TransactionPredicate = ({
    amount: amountReceiver,
    amountSender,
}) => !!amountSender && !isEqualAmount([amountSender, amountReceiver]);
